/* Allyant QA 5186: name image-only product/collection gallery links. */
(function () {
  const selector = 'a[class*="gallery-main-image-"], a[class*="gallery-all-image-"]';
  const labelGalleryImageLinks = (root) => {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(selector).forEach((link) => {
      const existingName = (link.getAttribute('aria-label') || '').trim();
      const visibleText = (link.textContent || '').trim();
      const imageAlt = Array.from(link.querySelectorAll('img'))
        .map((image) => (image.getAttribute('alt') || '').trim())
        .filter(Boolean)
        .join(' ');
      if (existingName || visibleText || imageAlt) return;
      const pathParts = new URL(link.href, window.location.href).pathname
        .split('/')
        .filter(Boolean);
      if (pathParts.length < 2) return;
      const type = pathParts[0];
      const title = pathParts[pathParts.length - 1]
        .replace(/[-_]+/g, ' ')
        .replace(/\b\w/g, (character) => character.toUpperCase());
      const destination = type === 'products' ? 'product' : type === 'collections' ? 'collection' : '';
      if (!destination) return;
      link.setAttribute('aria-label', 'View ' + destination + ': ' + title);
    });
  };
  if (document.querySelector(selector)) {
    labelGalleryImageLinks(document);
  } else {
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        labelGalleryImageLinks(document);
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', (event) => {
    labelGalleryImageLinks(event.target);
  });
})();

//build product-upsell web component

class ColorPagination extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    window.addEventListener('load', () => {
      const swiper = new Swiper(this.querySelector('.color-pagination'), {
        // Optional parameters

        slidesPerView: 'auto',
        allowSlideNext: true,
        allowSlidePrev: true,
        navigation: {
          nextEl: this.querySelector('.swipe-button-next'),
          prevEl: this.querySelector('.swipe-button-prev'),
        },
      })
    })
    this.querySelectorAll('.swiper-slide').forEach((slide) => {
      slide.addEventListener('click', () => {
        this.querySelector('.color-label').innerHTML =
          slide.getAttribute('color-value')
      })
    })
  }
}
customElements.define('color-pagination', ColorPagination)

// Hero Carousel

class ImageHeroCarousel extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    const swiper = new Swiper(this, {
      // Optional parameters
      slidesPerView: 1,
      loop: true,
      autoHeight: false,
      pagination: {
        el: this.querySelector('.hero-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-video-next',
        prevEl: '.swiper-video-prev',
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
    })
  }
}
customElements.define('image-hero', ImageHeroCarousel)

// sticky add to cart button on mobile pdp trigger deploy

function stickyAddToCartRules() {
  const mobileContainer = document.querySelector('.pdp__mobile-container')
  if (mobileContainer != null) {
    const targetLocation = document.querySelector('.mobile-location-container')

    window.addEventListener('scroll', function () {
      if (window.innerWidth <= 767) {
        const winHeight = window.innerHeight
        const scroll = window.pageYOffset
        const targetOffset = targetLocation.offsetTop

        if (scroll >= targetOffset + 100) {
          mobileContainer.classList.add('is-fixed')
          targetLocation.classList.add('is-under')
        } else {
          mobileContainer.classList.remove('is-fixed')
          targetLocation.classList.remove('is-under')
        }
      }
    })

    const trigger = document.querySelector('.pdp__mobile-fixed-options')

    if (trigger != null) {
      trigger.addEventListener('click', function () {
        document.querySelector('variant-radios').classList.toggle('is-active')
        this.classList.toggle('is-active')
      })

      const colorOptionsTrigger = document.querySelector(
        '.pdp__mobile-color-trigger',
      )
      const sizeOptionsTrigger = document.querySelector(
        '.pdp__mobile-size-trigger',
      )

      if (colorOptionsTrigger != null) {
        const firstRadioBackground = document.querySelector(
          'variant-radios input[checked] + label',
        ).style.backgroundColor
        colorOptionsTrigger.style.backgroundColor = firstRadioBackground
      }

      if (sizeOptionsTrigger != null) {
        const firstRadioText = document.querySelector(
          'variant-radios input[checked] + label > span',
        ).textContent
        sizeOptionsTrigger.textContent = firstRadioText
      }

      const radios = document.querySelectorAll(
        '.pdp__info__variant-radios__item label',
      )

      if (radios.length > 0) {
        radios.forEach((radio) => {
          radio.addEventListener('click', function () {
            if (colorOptionsTrigger != null) {
              const bgColor = this.style.backgroundColor
              colorOptionsTrigger.style.backgroundColor = bgColor
            }

            if (sizeOptionsTrigger != null) {
              const text = this.querySelector('span:first-child').textContent
              sizeOptionsTrigger.textContent = text
            }
          })
        })
      }
    }
  }
}

stickyAddToCartRules()

function sliderItems() {
  const slider = document.querySelector('.slider-items')

  const myslider = new Swiper(slider, {
    slidesPerView: 'auto',
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
  })
}

sliderItems()
